export const QUERY_KEY_MAP = {
  useGetPreInitDevices: 'useGetPreInitDevices',
  useGetDetectionZoneData: 'useGetDetectionZoneData',
  useGetPresenceZoneData: 'useGetPresenceZoneData',
  useEditDetectionZone: 'useEditDetectionZone',
  useGetOrgsData: 'useGetOrgsData',
  useGetUserDetails: 'useGetUserDetails',
  useEditPresenceZone: 'useEditPresenceZone',
  useGetStatusImage: 'useGetStatusImage',
  useGetRecentlyViewedDevices: 'useGetRecentlyViewedDevices',
  useEditRecentlyViewedDevices: 'useEditRecentlyViewedDevices',
  useGetZoneNotes: 'useGetZoneNotes',
  useEditZoneNotes: 'useEditZoneNotes',
  useListExternalUsers: 'useListExternalUsers',
  useListAuditLogs: 'useListAuditLogs',
  useGetZoneLastUpdatedMeta: 'useGetZoneLastUpdatedMeta',
  useGetManagementOrgs: 'useGetManagementOrgs',
  useGetManagementStores: 'useGetManagementStores',
  useGetManagementUser: 'useGetManagementUser',
  useGetSimCardDetails: 'useGetSimCardDetails',
  useGetAllSimCardDetails: 'useGetAllSimCardDetails',
  useGetSimDetail: 'useGetSimDetail',
  useGetDeviceZoneVersionHistory: 'useGetDeviceZoneVersionHistory',
  useGetDeviceDetails: 'useGetDeviceDetails',
  useListTasks: 'useListTasks',
  useGetVideoUrl: 'useGetVideoUrl',
  useGetDeviceHealth: 'useGetDeviceHealth',
  useEditExclusionZone: 'useEditExclusionZone',
  useGetExclusionZoneData: 'useGetExclusionZoneData',
  useGetInstallerNotes: 'useGetInstallerNotes',
  useEditInstallerNotes: 'useEditInstallerNotes',
  useGetDownDevices: 'useGetDownDevices',
  useGetRetryTaskConfigId: 'useGetRetryTaskConfigId',
  useListStores: 'useListStores',
  useGetStore: 'useGetStore',
  useGetRecentlyViewedOrgs: 'useGetRecentlyViewedOrgs',
  useRetrieveMaintenanceMode: 'useRetrieveMaintenanceMode',
  useRetrieveIndividualStoreReportFlag: 'useRetrieveIndividualStoreReportFlag',
  useRetrieveWeeklyReportDay: 'useRetrieveWeeklyReportDay',
  useRetrieveWelcomeExperience: 'useRetrieveWelcomeExperience',
  useListFailedReports: 'useListFailedReports',
  useListRetryReportLogs: 'useListRetryReportLogs',
  useListInstallManagement: 'useListInstallManagement',
  useGetInstallManagement: 'useGetInstallManagement',
  useGetInstallManagementOverview: 'useGetInstallManagementOverview',
  useGetInstallsByDevice: 'useGetInstallsByDevice',
  useGetInstallComments: 'useGetInstallComments',
  useGetInstallTimeline: 'useGetInstallTimeline',
  useGetPresenceZonesByDeviceIds: 'useGetPresenceZonesByDeviceIds',
  useGetStoreLayoutMap: 'useGetStoreLayoutMap',
  useGetInStoreBoundariesByDeviceIds: 'useGetInStoreBoundariesByDeviceIds',
  useListCustomerCentreFolders: 'useListCustomerCentreFolders',
  useListCustomerCentreFolderFiles: 'useListCustomerCentreFolderFiles',
  useGetDownDeviceById: 'useGetDownDeviceById',
  useInstallMapDevices: 'useInstallMapDevices',
  useGetInstallMapConfig: 'useGetInstallMapConfig',
  useListLiveAlerts: 'useListLiveAlerts',
  useGetReportIsPausedFlag: 'useGetReportIsPausedFlag',
  useGetPausedReportDetails: 'useGetPausedReportDetails',
  useGetReportBlacklist: 'useGetReportBlacklist',
  useGetAlertConfig: 'useGetAlertConfig',
  useGetStoreDeviceHours: 'useGetStoreDeviceHours',
} as const;
